// extracted by mini-css-extract-plugin
export default {"textBlock":"text-block_textBlock__GRrlQ"};